import React, { useState } from "react";
import { Trees, Building2, HeartHandshake } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import Footer from '../components/Footer';
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay, Navigation } from "swiper/modules";
import "../index.css";
import "swiper/css/navigation";

const projectData = {
  governmentsector: [
    {
      icon: <Trees size={18} />,
      title: "Airports Authority of India.",
      description: "We have successfully collaborated with the Airports Authority of India on structural design and engineering consultancy for airport infrastructure projects. Our scope included structural analysis, design validation, and technical coordination to ensure safety, durability, and compliance with national aviation and construction standards.",
      images: [
        {
          img: "/aaj-home/nmc-devadiya-hospital.jpeg",
          name: "NMC Devadiya Hospital Queta Colony, Nagpur .",
          cost: "₹ 4 CR",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/vidhan-bhavan.jpeg",
          name: "Vidhan Bhavan At Nava Raipur.",
          cost: "₹ 4 CR",
          status: "Completed",
        },
        {
          img: "/project/gv1.jpeg",
          name: "Fire station, ESR and Sump for Dr. Ambedkar International Airpot, Airport Authority of India, Nagpur.",
          cost: "₹ 4 CR",
          status: "Completed",
        },
        {
          img: "/project/gv2.jpg",
          name: "Fire station, ESR and Sump for Airport Authority of India, Gondia.",
          cost: "₹ 4 CR",
          status: "Ongoing",
        },
        {
          img: "/project/gv3.jpg",
          name: "Fire station, ESR and Sump for Airport Authority of India, Akola.",
          cost: "₹ 4.5 CR",
          status: "Completed",
        },
        {
          img: "/project/gv4.jpg",
          name: "CISF Barracks for Dr. Ambedkar International Airpot, Airport Authority of India, Nagpur.",
          cost: "₹ 3.22 CR",
          status: "Completed",
        },
        {
          img: "/project/gv5.jpg",
          name: "Modification of existing TerminalBuilding for Airport Authority of India, Akola.",
          cost: "₹ 13 Lacs",
          status: "Completed",
        },
        {
          img: "/project/gv6.jpeg",
          name: "Store hall for Dr. Ambedkar International Airpot, Airport Authority of India, Nagpur.",
          cost: "₹ 30 Lacs",
          status: "Completed",
        },

      ],
    },
    {
      icon: <Building2 size={18} />,
      title: "Visvesvaraya National Institute of Technology",
      description: "We have provided structural engineering services for academic and institutional infrastructure at VNIT, focusing on high-quality design, seismic safety, and sustainable construction practices. Our work ensured long-term structural stability while meeting institutional and regulatory requirements.",
      images: [
        {
          img: "/project/gvp1.jpeg",
          name: "Chemical Engineering Department",
          cost: "₹ 7.5 CR",
          status: "Ongoing",
        },
        {
          img: "/project/gvp2.jpeg",
          name: "Water Resources Engineering lab for Civil Department",
          cost: "₹ 42.95 Lacs",
          status: "Completed",
        },
        {
          img: "/project/gvp3.webp",
          name: "Classrooms for Metallurgy Department",
          cost: "₹ 27.91 Lacs",
          status: "Completed",
        },
        {
          img: "/project/gvp4.jpg",
          name: "Clean Room for Electronics Department",
          cost: "₹ 41.11 Lacs",
          status: "Completed",
        },
        {
          img: "/project/gvp4.jpg",
          name: "Department of Architecture (Extension)",
          cost: "₹ 1.3 CR",
          status: "Completed",
        },
        {
          img: "/project/Girls Hostel of Government College of Engineering Nagpur_Hostel.png",
          name: "Girls Hostel",
          cost: "₹ 8.5 CR",
          status: "Completed",
        },
        {
          img: "/project/gvp5.jpeg",
          name: "CanteenBuilding",
          cost: "₹ 1.5 CR",
          status: "Completed",
        },
        {
          img: "/project/gvp8.webp",
          name: "Class IV Employee Housing",
          cost: "₹ 7.5 CR",
          status: "Completed",
        },
        {
          img: "/project/gvp9.jpeg",
          name: "Sports Pavilion",
          cost: "₹ 2 CR",
          status: "Completed",
        },
        {
          img: "/project/gvp10.jpg",
          name: "Indoor Sports Stadium",
          cost: "₹ 6.5 CR",
          status: "Ongoing",
        },
      ],
    },
    {
      icon: <Building2 size={18} />,
      title: "Public Works Department.",
      description: "We have worked closely with the Public Works Department on government infrastructure projects, including buildings, public facilities, and institutional structures. Our services included structural analysis, design, detailing, and technical documentation in accordance with IS codes and government guidelines.",
      images: [
        {
          img: "/project/gvp31.jpg",
          name: "ITIBuilding at Achalpur",
          cost: "₹ 3 CR",
          status: "Completed",
        },
        {
          img: "/project/gvp32.jpeg",
          name: "Fast Track Court at Achalpur",
          cost: "₹ 30 lacs",
          status: "Completed",
        },
        {
          img: "/project/gvp33.jpeg",
          name: "Girl’s Hostel for Govt. Polytechnic at Yeotmal.",
          cost: "₹ 1.05 CR ",
          status: "Completed",
        },
        {
          img: "/project/gvp34.jpg",
          name: "MahilaTrainingCenter under Maharashtra Manav vikas Mission at Washim",
          cost: "₹ 50 Lacs ",
          status: "Completed",
        },
        {
          img: "/project/gvp35.jpg",
          name: "Academic building for Govt. Polytechnic at Murtizapur, Akola",
          cost: "₹ 15 CR",
          status: "Completed",
        },
        {
          img: "/project/gvp36.png",
          name: "WorkshopBuilding at Murtizapur",
          cost: "₹ 2 CR ",
          status: "Completed",
        },
        {
          img: "/aaj-home/baskar-university-raipuer.jpeg",
          name: "ITIBuilding at Shegaon",
          cost: "₹ 3 CR",
          status: "Completed",
        },
        {
          img: "/project/gvp38.jpg",
          name: "Govt.HospitalBuilding at Yeotmal",
          cost: "₹ 98 Lacs",
          status: "Completed",
        },
        {
          img: "/project/gvp39.jpg",
          name: "60 Bedded Hospital at Chandrapur.",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/gvp40.jpg",
          name: "CID Office Building at Gadchiroli.",
          cost: "₹ —-",
          status: "Ongoing",
        },
      ],
    },
    {
      icon: <Building2 size={18} />,
      title: "Nagpur Improvement Trust (N.I.T.)",
      description: "We have supported Nagpur Improvement Trust in urban development and infrastructure projects by providing reliable structural engineering solutions. Our work contributed to safe, efficient, and well-planned public and civic infrastructure development.",
      images: [
        {
          img: "/project/nit1.jpg",
          name: "Proposed residential complex on N.I.T. land at  Mz-Gadga plot no G106, G106a, Nagpur",
          cost: "₹ 1.5 CR",
          status: "Ongoing",
        },
        {
          img: "/project/nit2.jpg",
          name: "Sport academy at Processorvor Colony on open space at kh no.97 & Kh no 89/1,91/1,84,86,88,61/4 Mouza Parsodi, Swalambhi Society, Nagpur",
          cost: "₹ 3.0 CR",
          status: "Completed",
        },
        {
          img: "/project/nit3.jpg",
          name: "Library Building  at Aawale Chouk Laskaribagh Unit No. 4, Nagpur ",
          cost: "₹ 70 lac",
          status: "Ongoing",
        },
        {
          img: "/project/nit4.jpg",
          name: "Development of Play Ground &Hospital Project on Plot No. R, Kh.No.103/1, 103/2 At Mouza Chikhali (Deosthan), Nagpur, ",
          cost: "₹ 1.8 CR ",
          status: "Ongoing",
        },
        {
          img: "/project/nit5.jpeg",
          name: "Dr. Babasaheb Ambedkar Sports Complex at Ahuja Nagar, Nagpur. ",
          cost: "₹ 2.5 CR",
          status: "Ongoing",
        },
        {
          img: "/project/nit6.jpeg",
          name: " Proposed  Government  Girls Hostel For Adiwasi Development Division Of Nagpur  On Nit Land At Ganesh Nagar, Hiwari, Nagpur.",
          cost: "₹ 1.9 CR ",
          status: "Ongoing",
        },
      ],
    },
    {
      icon: <Building2 size={18} />,
      title: "Nagar Parishad.",
      description: "We have delivered structural consultancy services for Nagar Parishad projects, including municipal buildings, community facilities, and public infrastructure. Our approach ensured cost-effective, durable, and code-compliant structural designs for local governance needs.",
      images: [
        {
          img: "/aaj-home/nagar-parishad.jpg",
          name: " Retaining Wall for ResheshwarLake at Narkhed, Dist. Nagpur",
          cost: "₹ 70 lac",
          status: "Completed",
        },
        {
          img: "/aaj-home/nagar-parishad.jpg",
          name: "NagarParishadSchool at Narkhed, Dist. Nagpur",
          cost: "₹ 1.4 CR",
          status: "Completed",
        },
        {
          img: "/project/np1.jpg",
          name: "Shopping Complex for Umrer Nagar parishad. ",
          cost: "₹ 81 Lacs",
          status: "Completed",
        },
        {
          img: "/aaj-home/nagar-parishad.jpg",
          name: "Shopping cum Multipurpose Hall for Umrer Nagar parishad. ",
          cost: "₹ —-",
          status: "Completed",
        },

        {
          img: "/aaj-home/nagar-parishad.jpg",
          name: "Administrative building for M.C. Office for Arvi Nagar Parishad, Dist. Wardha",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/np2.jpeg",
          name: "Design of Auditorium for 600 capacity at Rajura. ",
          cost: "₹ —-",
          status: "Completed",
        },
      ],
    },
    {
      icon: <Building2 size={18} />,
      title: "M.I.D.C.",
      description: "We have worked on industrial infrastructure projects under MIDC, providing structural design and engineering support for factories, warehouses, and industrial buildings. Our designs prioritized load efficiency, durability, and safety for heavy-duty industrial use.",
      images: [
        {
          img: "/aaj-home/midc-itpark.jpg",
          name: "IT Park at MIDC Sadar, Nagpur",
          cost: "₹ 11 CR",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/midc.png",
          name: "Design of Jack Well at Marda On WardhaRiver. (10 m Dia and 25 m High)",
          cost: "₹ —-",
          status: "Completed",
        },
      ],
    },

  ],

  privatesector: [

    {
      icon: <HeartHandshake size={18} />,
      title: " Private Sector",
      description: " The private sector refers to businesses and organizations that are owned and operated by individuals or private companies rather than the government. It plays an important role in a country’s economic growth by creating jobs, encouraging innovation, and providing goods and services to the public. Companies in the private sector include IT firms, banks, manufacturing industries, hospitals, schools, and startups.",
      images: [
         
        {
          img: "/aaj-home/baskar-university-raipuer.jpeg",
          name: "Bastar University Raipur. ",
          cost: "₹ 3.75 CR",
          status: "Ongoing",
        },  
        {
          img: "/project/residential8.jpg",
          name: "KDK Engineering College at Umrer.",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/residential9.jpeg",
          name: "D.Ed.College at Bhadravati. ",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/residential10.jpeg",
          name: " D.PharmCollege at Warora.",
          cost: "₹ —- ",
          status: "Completed",
        },
         {
          img: "/project/residential13.jpg",
          name: " Resort at Kanha for Baidyanath.",
          cost: "₹ 3 CR ",
          status: "Completed",
        },
        {
          img: "/project/residential14.jpeg",
          name: "Resort at Bandhavgarh for Baidyanath. ",
          cost: "₹ 3 CR",
          status: "Completed",
        },
          {
          img: "/project/residential12.jpg",
          name: "Resort at Pench for Ar. Habeeb Khan, Nagpur ",
          cost: "₹ 2 CR",
          status: "Completed",
        },
         {
          img: "/project/poddar-school.jpg",
          name: "Poddar International School Nagpur, Ar. Lokesh Kadu ",
          cost: "₹ 6 CR",
          status: "Ongoing",
        },
        {
          img: "/project/residential1.jpg",
          name: "Design of Auditorium Hall for ModernSchool, Nagpur. (G+2, with total Ht. of 58’6”)",
          cost: "₹ 3.75 CR",
          status: "Completed",
        },
       {
          img: "/project/private-sector2.jpg",
          name: "Technical University for Jilla Nirmaan Samiti at Dantewada Raipur, Ar. Sandeep Shrivastav.",
          cost: "₹ 10 CR",
          status: "Ongoing",
        },
            {
          img: "/project/private-sector3.jpeg",
          name: "UASB Tanks  (11m, 18.4m), ETP Tanks (3m, 6.5m, 14.6m), Tube Settler tank (8m x 14.6m), Aerobic Filter for LARS Enviro, Nagpur ",
          cost: "₹ —-",
          status: "Completed",
        },
        
        {
          img: "/project/residential18.jpeg",
          name: "Double height Marriage hall with 15 m span RCC roof at Ramtek.",
          cost: "₹ 46 Lacs",
          status: "Completed",
        },
      ],
    },
    {
      icon: <HeartHandshake size={18} />,
      title: "Luxury Residential",
      description: "We have designed and executed structural solutions for residential buildings including individual houses, apartments, and housing complexes. Our designs focus on safety, space optimization, cost efficiency, and compliance with building regulations.",
      images: [
             {
          img: "/aaj-home/embassyll-ms-kukreja-infrastructure.jpeg",
          name: "Embassy ll, Ms Kukreja Infrastructure, Nagpur ",
          cost: "₹ 5.75 CR",
          status: "Ongoing",
        },
         {
          img: "/aaj-home/1.jpg",
          name: "Haldiram Om Tatsat (2B + G + 29) ",
          cost: "₹ —-",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/nirmal-trinity.jpeg",
          name: "Nirmal Trinity Towers At Umred Road",
          cost: "₹ 2.50 CR",
          status: "Ongoing",
        },
        
        {
          img: "/project/residential2.avif",
          name: "G+5 (50000 Sq.ft.) Residential scheme at Besa, Nagpur. ",
          cost: "₹ 4.1 CR",
          status: "Completed",
        },
        {
          img: "/project/residential3.jpg",
          name: " G+5 (40000 Sq.ft.) Residential scheme at Besa, Nagpur.",
          cost: "₹ 3.2 CR",
          status: "Completed",
        },
        {
          img: "/project/residential4.jpg",
          name: "9 storied building (Hyatt Majestics) for Millennium Dev. And Pro. Pvt. Ltd. Nagpur.",
          cost: "₹ 3.74 CR ",
          status: "Completed",
        },
        {
          img: "/project/residential5.jpg",
          name: "7 storied building for Arafat Dwellers Nagpur.",
          cost: "₹ 8 CR",
          status: "Completed",
        },
        {
          img: "/project/residential6.jpeg",
          name: "6 storied building for Tristar Concepts Pvt. Ltd. Nagpur.",
          cost: "₹ 4.75 CR",
          status: "Completed",
        },      
       
        {
          img: "/project/residential19.jpeg",
          name: "Design of flat schemes and duplexes for Mr. N.C. Biyani at Chandrapur. ",
          cost: "₹ 1.3 CR",
          status: "Completed",
        },
        {
          img: "/project/residential20.jpeg",
          name: " Boy’s Hostel For Datta Maghe at Sawangi, Wardha",
          cost: "₹ 1.2 CR",
          status: "Completed",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: " Industrial building (G+6) Mr. Manniyar at Butibori",
          cost: "₹ 1.5 CR",
          status: "Completed",
        },
      
        {
          img: "/aaj-home/residential-logo2.png",
          name: " Belivers Church at Kalmeshwar.",
          cost: "₹ 7.5 CR",
          status: "Ongoing",
        },
       
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Dr. Khemka’s Hospital (1.35 Lacs Sq.Ft.)building at Raipur For Ar. Sandeep Shrivastav. ",
          cost: "₹ 10 CR",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: " DPS school buildings at Raipur For Ar. Sandeep Shrivastav.",
          cost: "₹ —-",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Gondia Hotel Building (area 50,000 Sq.Ft) Ar. Virendra Khare. ",
          cost: "₹ 6 CR",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: " Maheshwari Bhavan at Raipur, Ar. H.R. Malani.",
          cost: "₹ 10 CR",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: " Gujrati Bhavan at Raipur, Ar. R.K. Patel",
          cost: "₹ 5 CR",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Jain Manas Samiti at Raipur, Ar. Sandeep Shrivastav. ",
          cost: "₹ 10 CR",
          status: "Ongoing",
        },
       
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Panchayat Building at Naya Raipur, Ar. Dewakriti Rao. ",
          cost: "₹ —-",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Green Space Infra at Nagpur, Ar. Axial Planners. ",
          cost: "₹ —- ",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "St. Paul Church At Raipur, Ar. Sandeep Shrivastav. ",
          cost: "₹ —- ",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Tulsi city at Butibori, Nagpur. ",
          cost: "₹ 20 CR",
          status: "Completed",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Sumangal Vihar at Essasani Nagpur, Ar. Ravi Sonkusare ",
          cost: "₹ 40 CR",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: " Sandesh City at Butibori, Nagpur.",
          cost: "₹ 50 CR",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: " Pushkar Homes Pvt. Ltd. At Butibori Nagpur, Ar. Virendra Khare.",
          cost: "₹ 10 CR ",
          status: "Ongoing",
        },
        
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Proposed EWS,LIG,MIG Building for Chattisgarh Housing Board Raipur, Ar. Sandeep Shrivastav",
          cost: "₹ —-",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Suchna and Yojna Aayog Building at Naya Raipur, Ar. R.K. Patel ",
          cost: "₹ —-",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: " Jail and Home Guard Building at Naya Raipur, Ar. R.K. Patel.",
          cost: "₹ —-",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Residential Appartment Scheme for M/s RGF Pvt. Ltd. At Raigarh, Ar. Satish Bhaskar and Associates.",
          cost: "₹ —-",
          status: "Ongoing",
        },
       
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Residential Appt. Scheme at Nagpur for Raj Infra Nagpur, Ar. Lokesh Kadu. ",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: " Kasturi Nagar Group Housing for Sky Developers Nagpur, Ar. Axial Planners.",
          cost: "₹ —-",
          status: "Ongoing",
        },
        {
          img: "/aaj-home/residential-logo2.png",
          name: "Residential Appt. Scheme at Nagpur for K. D. Padole Group Nagpur, Ar. Vikas Padole.",
          cost: "₹ —-",
          status: "Ongoing",
        },
      ],
    },

    {
      icon: <HeartHandshake size={18} />,
      title: "Commercial ",
      description: "We have provided structural engineering services for commercial buildings such as offices, retail spaces, and mixed-use developments. Our expertise ensures strong, functional, and aesthetically compatible structural systems tailored to business needs.",
      images: [
        {
          img: "/project/Commercial1.webp",
          name: " Gaurav Square",
          cost: "₹ 3.75 CR",
          status: "Completed",
        },
          {
          img: "/project/residential7.jpeg",
          name: "6 storied Commercial building for Tristar Concepts Pvt. Ltd. Nagpur.",
          cost: "₹ 2.5 CRr",
          status: "Ongoing",
        },
      
          {
          img: "/aaj-home/Commercial logo.png",
          name: "Commercial scheme (B+7) for M/s Singhania Buildcon Pvt. Ltd. at Raipur ",
          cost: "₹ 10 CR",
          status: "Ongoing",
        },
         {
          img: "/aaj-home/Commercial logo.png",
          name: "Commercial Complex for M/s Singhania Bulidcon at Raipur, Ar. Sandeep Shrivastav.",
          cost: "₹ 8 CR",
          status: "Completed",
        },
         {
          img: "/aaj-home/Commercial logo.png",
          name: " Commercial Building (For Mr. Nitin Agrawal)) at Raipur (B+G+4) For Ar. Sandeep Shrivastav.",
          cost: "₹ 3.5 CR",
          status: "Ongoing",
        },
          {
          img: "/aaj-home/Commercial logo.png",
          name: "Commercial Building (Atlantis) at Raipur (B+G+7) For Ar. Sandeep Shrivastav. ",
          cost: "₹ 6 CR",
          status: "Completed",
        },
         {
          img: "/project/residential16.webp",
          name: "Shed for factory at old Umiya, Bhandara road, Nagpur.",
          cost: "₹ —-",
          status: "Ongoing",
        },
          {
          img: "/project/residential11.webp",
          name: "Industrial Truss of span 34.5 m at MIDC Hingna for M/s Supriya Packaging, Nagpur ",
          cost: "₹ —-",
          status: "Completed",
        },
         {
          img: "/project/residential15.jpeg",
          name: "Complete Industrial Project for ARC TEC Systems Ltd. At Butibori Nagpur ",
          cost: "₹ 10.25 CR",
          status: "Completed",
        },
         {
          img: "/project/nursing-home.jpeg",
          name: "Nursing Home for Care Group at Gondia. (4.5 storied) ",
          cost: "₹ 80 Lacs",
          status: "Completed",
        },
        {
          img: "/aaj-home/Commercial logo.png",
          name: "Annexe Building of Dental College Belonging To Swargiya Dadasaheb Kalmegh Smruti Pratishtan At Wanadongri, Hingna, Nagpur. ",
          cost: "₹ 3.6 CR ",
          status: "Ongoing",
        },
      ],
    }
  ],

  SpecialProject: [
    {
      icon: <HeartHandshake size={18} />,
      title: " Special Projects",
      description: "We have handled complex and specialized projects requiring advanced structural analysis, innovative design solutions, and technical expertise. These include high-rise buildings, large-span structures, heritage restorations, and unique architectural designs.",
      images: [

        {
          img: "/project/isro-logo.png",
          name: "Design of Double Leaf Steel Sliding Gate 7m wide x 13.5m high for Signum Fires Pvt. Ltd. Nagpur. (For ISRO)",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special2.jpeg",
          name: "Static and Seismic Stability of Fire Rated Doors for Signum Fires Pvt. Ltd. Nagpur. (For Nuclear Power Corporation of India Ltd., Kudankulam)",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special3.jpeg",
          name: "32 Lacs Ltrs. Elevated Service Reservoir for AUG. RAIPUR W.S. SCHEME.",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special4.jpeg",
          name: "Soyabeen Extraction Plant for M/s Soya Agro.",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special5.jpeg",
          name: "Chattisgarh Housing board Club House at Raipur.",
          cost: "₹ 10 CR",
          status: "Completed",
        },
        {
          img: "/project/special6.jpeg",
          name: "Design of 168 Quarters at Gadchiroli for Maharashtra State Police Housing& Welfare Corporation Ltd. MUMBAI.",
          cost: "₹ 16 CR",
          status: "Completed",
        },
        {
          img: "/project/special7.jpg",
          name: "Mobile Roof Top Tower foundation design for BSNL-ALCATEL project for Vidarbha Region.",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special71.jpg",
          name: "MobileRoofTopTower foundation design for BHARTI Air Tel project for Vidarbha Region.",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special8.jpeg",
          name: "State Bank of IndiaBuilding at Wani",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special9.jpeg",
          name: "Soyabin Extraction Plant and Godown (90x100m)",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special10.jpeg",
          name: "Congress Committee Building at Chandrapur.",
          cost: "₹ 2.4 CR",
          status: "Completed",
        },



        {
          img: "/project/special11.jpeg",
          name: "Tree House for Sandeep Dwellers Pvt. Ltd. At Pench.",
          cost: "₹ —-",
          status: "Completed",
        },
        {
          img: "/project/special12.jpeg",
          name: "Baidyanath Corporate Office at Nagpur.",
          cost: "₹ —-",
          status: "Ongoing",
        },
      ],
    },
  ],
};

const ProjectsPage = () => {
  const [activeTab, setActiveTab] = useState("governmentsector");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const formatLabel = (text) =>
    text
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/sector/i, " Sector")
      .replace(/project/i, " Project")
      .replace(/^./, (str) => str.toUpperCase());
  const openModal = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedItem(null);
    setModalOpen(false);
  };
  return (
    <div className="min-h-screen bg-gray-50">

      {/* HERO SECTION */}
      <section
        className="relative flex items-center justify-center text-white overflow-hidden"
        style={{
          backgroundImage: "url(/aaj-home/hero-project.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative z-10 max-w-7xl px-4 sm:px-8 md:px-16 lg:px-20 text-center py-24 md:py-32 lg:py-40">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-6">
            <span className="bg-white bg-clip-text text-transparent drop-shadow-lg">
              Projects
            </span>
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed">
            Explore our portfolio of successfully completed residential
            construction projects that showcase our commitment to quality,
            innovation, and customer satisfaction.
          </p>
        </div>
      </section>

      {/* FILTER BUTTONS */}
      <div className="px-4 sm:px-8 md:px-16 lg:px-20 mt-10 flex flex-wrap gap-6 sm:gap-8">
        {["governmentsector", "privatesector", "SpecialProject"].map((tab) => (
          <div
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`relative cursor-pointer pb-2 text-base sm:text-lg font-semibold transition-all ${activeTab === tab
              ? "font-bold text-[#011321]"
              : "text-gray-600 hover:text-gray-800"
              }`}
          >
            {formatLabel(tab)}

            {activeTab === tab && (
              <span className="block w-16 sm:w-24 md:w-32 lg:w-40 h-0.5 sm:h-1 
          bg-gradient-to-r from-yellow-500 via-yellow-300 to-white 
          rounded-full mt-2">
              </span>
            )}
          </div>
        ))}
      </div>

      {/* PROJECT LIST */}
      <div className="px-6 md:px-20 mt-12">
        {projectData[activeTab].map((project, index) => (
          <div key={index} className="mb-16">

            {/* TITLE ROW */}
            <div className="flex items-center gap-3">
              <div className="w-10 h-10  bg-[#00B9F1] rounded-full flex items-center justify-center text-white font-bold">
                {project.icon}
              </div>
              <h2 className="text-lg sm:text-4xl font-semibold text-[#1A1A3D]">
                {project.title}
              </h2>
            </div>

            {/* Underline */}
            <div className="w-full h-[4px] bg-[#00B9F1] mt-6 mb-4"></div>

            {/* Description */}
            <p className="text-gray-600 mb-8 max-w-8xl">
              {project.description}
            </p>

            {/* IMAGES SWIPER */}
            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={16}
              slidesPerView={4}
              loop={true}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              navigation={true}
              className="py-4"
              breakpoints={{
                320: { slidesPerView: 1 },
                640: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
              }}
            >
              {project.images.map((item, i) => (
                <SwiperSlide key={i}>
                  <div
                    onClick={() => openModal(item)}
                    className="relative w-full h-[220px] rounded-2xl overflow-hidden shadow-md group cursor-pointer"
                  >
                    <img
                      src={item.img}
                      alt={item.name}
                      className="w-full h-full object-fill transition duration-300 group-hover:scale-105"
                    />

                    {/* BOTTOM INFO */}
                    <div className="absolute bottom-0 left-0 w-full bg-black bg-opacity-60 p-3 flex flex-col gap-1">
                      <h3 className="text-sm md:text-base font-semibold text-white truncate">
                        {item.name}
                      </h3>
                      <p className="text-xs text-gray-200">Cost: {item.cost}</p>
                      <p
                        className={`text-xs font-semibold ${item.status === "Completed"
                          ? "text-green-400"
                          : "text-yellow-400"
                          }`}
                      >
                        Status: {item.status}
                      </p>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>


          </div>
        ))}
      </div>

      {/* MODAL */}
      {modalOpen && selectedItem && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70 p-4">
          <div className="bg-white rounded-2xl max-w-lg w-full relative overflow-hidden shadow-lg">
            {/* Close Button */}
            <button
              onClick={closeModal}
              className="absolute top-3 right-3 text-red text-2xl font-bold  "
            >
              &times;
            </button>

            {/* Image */}
            <img
              src={selectedItem.img}
              alt={selectedItem.name}
              className="w-full h-80 md:h-[500px] object-fill"
            />

            {/* Info */}
            <div className="p-6">
              <h3 className="text-xl font-semibold text-gray-800">{selectedItem.name}</h3>
              <p className="text-gray-600 mt-2">Cost: {selectedItem.cost}</p>
              <p className={`mt-1 font-semibold ${selectedItem.status === "Completed" ? "text-green-500" : "text-yellow-500"}`}>
                Status: {selectedItem.status}
              </p>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
export default ProjectsPage;
